import {h, Fragment} from "preact"
import { useFacet, useAppState } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"
import { useState, useEffect } from "preact/hooks"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const appState = useAppState()
    const {
        response: { products }
    } = appState

    // State to store size availability counts
    const [sizeAvailability, setSizeAvailability] = useState({})

    useEffect(() => {
        if (facet.name === "Size") {
            // Fetch all products with SKU availability data
            const token = "B9PxhCt2q7NHKdb1scwWh3hXhzMqedWoQQ6SX4kDHJHjElITrP3M14wPwEhJx6Tg"
            const tokenSearch = "Mgr7EceSvyAbGYiPmWVk3EWZiC3FVH8pnEj8QJn8IDmuLFRojQz88CjvtUwjSaVQ"

            // Get dynamic values from appState
            const categoryId = appState?.query?.products?.categoryId || ""
            const categoryPath = appState?.query?.products?.categoryPath || ""
            const size = 1000 // Fetch all products
            const from = appState?.query?.products?.from || 0

            // Get active filters from appState, excluding size filters
            const activeFilters = appState?.query?.products?.filter || []
            const nonSizeFilters = activeFilters.filter((f) => !f.field.includes("size"))

            // Build the filter string for GraphQL if there are active filters
            let filterString = ""
            if (nonSizeFilters.length > 0) {
                const filterObjects = nonSizeFilters
                    .filter((filter) => (filter.value && Array.isArray(filter.value) && filter.value.length > 0) || filter.range)
                    .map((filter) => {
                        if (filter.range) {
                            // Handle range filters (e.g., price)
                            const rangeConditions = filter.range.map((r) => {
                                const conditions = Object.entries(r).map(([key, val]) => `${key}: "${val}"`).join(", ")
                                return `{${conditions}}`
                            }).join(", ")
                            return `{field: "${filter.field}", range: [${rangeConditions}]}`
                        } else {
                            // Handle value filters
                            const values = filter.value.map((v) => `"${v}"`).join(", ")
                            return `{field: "${filter.field}", value: [${values}]}`
                        }
                    })
                    .join(", ")
                if (filterObjects) {
                    filterString = `, filter: [${filterObjects}]`
                }
            }

            // GraphQL query to fetch all products with dynamic values and filters
            const query = `
                query {
                    search(
                        accountId: "shopify-12583447"
                        products: {categoryId: "${categoryId}", categoryPath: "${categoryPath}", size: ${size}, from: ${from}, facets: ["*"]${filterString}}
                    ) {
                        products {
                        hits {
                            availability
                            skus {
                                id
                                name
                                availability
                            }
                        }
                        total
                        }
                    }
                }
            `


            fetch("https://search.nosto.com/v1/graphql", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Basic " + btoa(":" + tokenSearch)
                },
                body: JSON.stringify({
                    query: query
                })
            })
                .then((response) => response.json())
                .then((json) => {
                    // Calculate size availability
                    if (json?.data?.search?.products?.hits) {
                        const hits = json.data.search.products.hits
                        const sizeCounts = {}

                        // Iterate through each product
                        hits.forEach((hit) => {
                            // Only count products that are in stock
                            if (hit.availability === "InStock" && hit.skus) {
                                // Check each SKU/size in the product
                                hit.skus.forEach((sku) => {
                                    // Only count if the specific size is in stock
                                    if (sku.availability === "InStock" && sku.name) {
                                        const sizeName = sku.name
                                        sizeCounts[sizeName] = (sizeCounts[sizeName] || 0) + 1
                                    }
                                })
                            }
                        })

                        setSizeAvailability(sizeCounts)
                    }
                })
                .catch((error) => {
                    console.error("Error fetching products:", error)
                })
        }
    }, [appState])

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                // class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-p-4"
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated padding-4-vertical"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={toggleActive}
                // onClick={setActive(!active)}
            >
                <span class="ns-color-black ns-font-4">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <Icon name="arrow" className="ns-absolute" />
            </a>
            {/* <div class="ns-sidebar-submenu ns-d-none ns-p-4"> */}
            <div class="ns-sidebar-submenu ns-d-none">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {facet.data?.map((value) => {
                        const displayCount =
                            facet.name === "Size" && Object.keys(sizeAvailability).length > 0 ?
                                sizeAvailability[value.value] || 0
                            :   value.count

                        return (
                            <li
                                class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                                data-nosto-element="facet-setting"
                            >
                                <Checkbox
                                    value={value.value}
                                    selected={value.selected}
                                    onChange={(e) => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }}
                                />
                                {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-background-grey-light ns-border-radius-3">
                                    {value.count}
                                </span> */}
                                <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-border-radius-3">
                                    ({displayCount})
                                </span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </li>
    )
}
